export function normalizeMac(address: string): string {
  return address.replace(/[^0-9a-fA-F]/g, '').toUpperCase();
}

export function formatMac(address: string): string {
  const normalized = normalizeMac(address);

  if (normalized.length !== 12) {
    return normalized;
  }

  const pairs = normalized.match(/.{1,2}/g);
  return pairs ? pairs.join(':') : normalized;
}
